import './LadderChips.scss';
import cn from 'classnames';
import { DataQaThresholds, ForecastLadderRung, ScalingLadderRung } from '../../dataQaContract';
import { failCopy, grainLabel } from '../data-qa-utils';

export const LadderChips = ({
  label,
  ladder,
  thresholds
}: {
  label: string;
  ladder: (ForecastLadderRung | ScalingLadderRung)[];
  thresholds: DataQaThresholds;
}) => (
  <div className='dq-ladder-row'>
    <span className='dq-ladder-label'>{label}</span>
    <div className='dq-ladder'>
      {ladder.map(rung => {
        let title = 'Not offered at this grain';
        let cls = 'dq-muted-chip';
        if (rung.offered && rung.eligible) {
          title = 'Passes at this grain';
          cls = 'dq-pass';
        } else if (rung.offered) {
          title =
            rung.fail_reasons.map(fr => failCopy(fr, thresholds)).join('; ') ||
            'Fails at this grain';
          cls = 'dq-none';
        }
        return (
          <span key={rung.grain} className={cn('dq-chip', cls)} title={title}>
            {grainLabel(rung.grain)}
          </span>
        );
      })}
    </div>
  </div>
);
